import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {PricesAddressLayout} from "../layout/PricesAddressLayout";

export const PricesAddressView = () => {
    const region = useSelector((state: IRPStore) => state.report.price.region);
    const address = useSelector((state: IRPStore) => state.report.price.address);
    const availableRooms = useSelector((state: IRPStore) => state.report.price.addressRooms);

    if (!region || !address) {
        return null;
    }

    return <PricesAddressLayout cityRegion={region} address={address} availableRooms={availableRooms} />;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../../app/rp_reducer";
import {PricesAddressLayout} from "../layout/PricesAddressLayout";

export const PricesAddressView = () => {
    const region = useSelector((state: IRPStore) => state.report.price.region);
    const address = useSelector((state: IRPStore) => state.report.price.address);
    const availableRooms = useSelector((state: IRPStore) => state.report.price.addressRooms);

    if (!region || !address) {
        return null;
    }

    return <PricesAddressLayout cityRegion={region} address={address} availableRooms={availableRooms} />;
};
